module.exports = __webpack_public_path__ + "static/mmmobile-bbfcdccc70084a5860f3846421fdc947.png";